// Centralized RAQ Technologies contact info.
// IMPORTANT: components MUST render these values via <RevealContact /> so they
// are never visible in the rendered HTML to scrapers / crawlers.
export const RAQ_CONTACTS = {
  phone: '450-876-0989',
  emails: {
    sales: 'ventes@raq-canada.com',
    support: 'support@raq-canada.com',
    accounting: 'facturation@raq-canada.com',
    customerService: 'info@raq-canada.com',
  },
};
